module.exports = __webpack_public_path__ + "static/IMCapital-0de1190d4bd593ac99a2503b0281d85d.png";